import api from './client';

export interface EmailListItem {
  id: number;
  message_id: string;
  sender: string;
  subject: string;
  has_attachment: boolean;
  attachment_name: string | null;
  received_at: string | null;
  fetched_at: string;
  processed_by: string | null;
  processing_result: string | null;
}

export interface EmailDetail extends EmailListItem {
  body: string;
  attachment_path: string | null;
  processed_at: string | null;
  processing_details: string | null;
}

export interface InboxResponse {
  items: EmailListItem[];
  total: number;
}

export interface OutboxItem {
  id: number;
  to_email: string;
  subject: string;
  module_name: string;
  status: string;
  error_message: string | null;
  attempts: number;
  created_at: string;
  sent_at: string | null;
}

export interface OutboxResponse {
  items: OutboxItem[];
  total: number;
}

export interface HealthSummary {
  imap_last_success: string | null;
  imap_last_error: string | null;
  imap_success_rate_24h: number;
  smtp_last_success: string | null;
  smtp_last_error: string | null;
  smtp_success_rate_24h: number;
  recent: HealthEntry[];
}

export interface HealthEntry {
  check_type: string;
  success: boolean;
  error_message: string | null;
  duration_ms: number;
  checked_at: string;
}

export interface CheckResult {
  fetched: number;
  dispatched: number;
  details: string[];
}

export interface SubscriptionItem {
  id: number;
  module_name: string;
  handler_name: string;
  sender_filter: string | null;
  subject_filter: string | null;
  require_attachment: boolean;
  is_active: boolean;
  priority: number;
  created_at: string;
  last_triggered_at: string | null;
}

export interface SubscriptionsResponse {
  items: SubscriptionItem[];
}

export const mailApi = {
  getInbox: (params?: { page?: number; page_size?: number; sender?: string; result?: string }) =>
    api.get<InboxResponse>('/mail/inbox', { params }),
  getInboxDetail: (id: number) => api.get<EmailDetail>(`/mail/inbox/${id}`),
  downloadAttachment: (id: number) =>
    api.get<Blob>(`/mail/inbox/${id}/attachment`, { responseType: 'blob' }),
  getOutbox: (params?: { page?: number; page_size?: number; status?: string }) =>
    api.get<OutboxResponse>('/mail/outbox', { params }),
  getHealth: () => api.get<HealthSummary>('/mail/health'),
  triggerCheck: () => api.post<CheckResult>('/mail/check'),
  getSubscriptions: () => api.get<SubscriptionsResponse>('/mail/subscriptions'),
};
